import { render, staticRenderFns } from "./userFeedBackView.vue?vue&type=template&id=8502fbb8&scoped=true&"
import script from "./userFeedBackView.vue?vue&type=script&lang=js&"
export * from "./userFeedBackView.vue?vue&type=script&lang=js&"
import style0 from "./userFeedBackView.vue?vue&type=style&index=0&id=8502fbb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8502fbb8",
  null
  
)

export default component.exports